import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

import { ProductFilter } from './ProductFilter';
import { StatusFilter } from './StatusFilter';
import { ChangeTypeFilter } from './ChangeTypeFilter';
import { SearchInput } from './SearchInput';
import { ApplyButton } from './ApplyButton';
import { ResetButton } from './ResetButton';

const filterContainerStyles = xcss({
  display: 'flex',
  gap: 'space.200',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
});

interface AppUpdatesFiltersProps {}

export const AppUpdatesFilters: React.FC<AppUpdatesFiltersProps> = () => {
  return (
    <Box xcss={filterContainerStyles} testId="app-updates-table-filters-testid">
      <SearchInput />
      <ProductFilter />
      <StatusFilter />
      <ChangeTypeFilter />
      <ApplyButton />
      <ResetButton />
    </Box>
  );
};

export default AppUpdatesFilters;
